<template>
    <div class="scenario-scrollable-container" v-if="isVisible">
        <div class="scenario-section">
            <div
                style="width: 100%; height: 35px; overflow: hidden; padding: 5px; justify-content: space-between; display: flex; align-items: center;">
                <div
                    style="width: 350px; height:35px; align-items: center; display: flex; flex-shrink: 0;">
                    <img :src="NodeIconMap[testNodeType]" alt="icon" class="mr-1" style="width: 20px; height: 20px">
                    <h3>{{ testNodeName }}</h3>
                </div>
                <div style="width: 80px; height:20px; display: flex; align-items: center; margin-left: auto">
                    <h3 style="margin-right: 10px; max-width: 70px; float: right">Variable</h3>
                    <div class="scenario-close-button">
                      <img src="/img/scenario/close.svg" @click="close" :title="$f.tc('close')" alt="icon-close"
                           style="transform: scale(0.9)">
                    </div>
                </div>
                <div class="clearfix" style="clear: both"></div> <!-- Clears float -->
            </div>
            <div class="scenario-section-content">
                <table>
                    <thead>
                    <tr>
                        <th class="cell_name">Name</th>
                        <th class="cell_value">Value</th>
                        <th class="cell_check">Data Collection</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, key) in testData" :key="key">
                        <td class="cell_name">{{ key }}</td>
                        <td class="cell_value">
                            <pre v-if="isObject(value.data)">{{ prettyJson(value.data) }}</pre>
                            <span v-else>{{ value.data }}</span>
                        </td>
                        <td class="cell_check" style="text-align: center">
                            <span v-if="value.isDataCollection" style="font-size: 18px;">✓</span>
                            <span v-else></span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ScenarioService from "@/services/scenario.service";

const {NodeType, NodeIconMap} = ScenarioService
export default {
    name: "ScenarioTestVariable",
    props: {
        testData: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        isVisible: {
            type: Boolean,
            default: false,
            required: false
        },
        testNodeName: {
            type: String,
            required: false,
            default: ""
        },
        testNodeType: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            NodeType,
            NodeIconMap
        }
    },
    methods: {
        isObject(value) {
            return typeof value === 'object' && value !== null && !Array.isArray(value);
        },
        prettyJson(value) {
            return JSON.stringify(value, null, 2); // Pretty-print with 2-space indentation
        },
        close() {
            this.$emit('change-visibility', false)
        }
    }
}
</script>


<style scoped lang="scss">
$nextToLeftWidth: 550px;
:deep(.scenario-scrollable-container) {
    background-color: #e0e0e0;
    border: 1px solid #ddd;
    padding: 10px;
    display: flex;
    flex-direction: column;
    max-width: $nextToLeftWidth;
    min-width: $nextToLeftWidth;
}

.scenario-section {
    border: 1px solid #ccc;
    background-color: #FFFFFF;
    padding: 5px;
    width: auto;
}

.scenario-section-content {
    overflow: auto;
    height: calc(100vh - 220px);
}

/* Bottom spacing */

table {
    max-width: 100%;
    min-width: 100%;
    border-collapse: collapse;
    margin-top: 5px;
}

th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

.cell_name {
    width: 150px; /* Set fixed width */
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
}

.cell_value {
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
}

.cell_check {
    width: 100px; /* Set fixed width */
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
}

th {
    background-color: #f2f2f2;
}

pre {
    margin: 0;
    white-space: pre-wrap;
    font-family: monospace;
}

.scenario-close-button:hover {
    cursor: pointer;
}
</style>
